/* eslint-disable guard-for-in */
/* eslint-disable no-param-reassign */
import qs from 'qs';

export default {
  exchangeParams(params) { // 处理传参序列化

    const str = qs.stringify(params).split(/%5B|%5D/g);
    const arr = [];
    str.forEach((el) => {
   
  
      if (el) {
        if (!Number.isNaN(el * 1)) {
          el = `%5B${el}%5D`;
        }
        arr.push(el);
      }
    });
    return arr.join('.').replace(/\.=/g, '=').replace(/\.%/g, '%');
    // console.log(params);
    // if (params) {
    //   return JSON.stringify(params);
    // }
    // return '';
  },
  isValue(value) {
    return value !== '' && value !== null && value !== undefined;
  },
};
